import { render, staticRenderFns } from "./MyAnamnesesPage.vue?vue&type=template&id=e811e35e&scoped=true"
import script from "./MyAnamnesesPage.vue?vue&type=script&lang=js"
export * from "./MyAnamnesesPage.vue?vue&type=script&lang=js"
import style0 from "./MyAnamnesesPage.vue?vue&type=style&index=0&id=e811e35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e811e35e",
  null
  
)

export default component.exports